import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import intlShape from '@/shared/utils/intlShape';

import OkCancelModal from '@/shared/components/OkCancelModal';

import DatePicker from '@/shared/components/input/DatePicker';
import { isBeforeMinimum } from '@/shared/utils/validationHelpers';
import messages from '../documentMessages';

export default class ChangeDocumentDateModal extends Component {
  state = {
    documentDate: undefined,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  onSave = () => {
    const { documentDate } = this.state;
    const { onSave, intl } = this.props;
    if (!documentDate || isBeforeMinimum(documentDate)) {
      ToastrService.error(intl.formatMessage(messages.InvalidDate));
      return;
    }
    return onSave({ documentDate });
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const { documentDate, dateFocused } = this.state;
    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeDocumentDate)}
        show={show}
        onClose={this.closeModal}
        disabled={false}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <label className="control-label col-md-3">
                <FormattedMessage {...messages.DocumentDate} />
              </label>
              <div className="col-md-9">
                <DatePicker
                  placeholder={intl.formatMessage(messages.DocumentDate)}
                  date={documentDate}
                  onDateChange={date =>
                    this.setState(state => ({
                      ...state,
                      documentDate: date,
                    }))
                  }
                  focused={dateFocused}
                  onFocusChange={({ focused }) => this.setState({ dateFocused: focused })}
                  id="documentDate"
                  required
                  block
                  small
                  isOutsideRange={isBeforeMinimum}
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
